import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

import './libraries/smooth-scroll.js'
import './libraries/simplelightbox.min.js'

import header from './partials/header'
import menu from './partials/menu'
import lightboxModal from './partials/lightbox-modal.js'

window.addEventListener('DOMContentLoaded', () => {
  // Partials
  header()
  menu()
  lightboxModal()

  // Clipboard Copy
  const clipboardCopyCheck = document.querySelector('.js-copy-url')

  if (clipboardCopyCheck) {
    import('./libraries/clipboard-copy')
      .then(({ default: clipboardCopy }) => {
        clipboardCopy()
      })
      .catch((error) => {
        console.error("Error loading 'Clipboard Copy' module:", error)
      })
  }

  // Webpage Download (PDF to HTML)
  const webpageDownloadCheck = document.querySelector('.html-to-pdf')

  if (webpageDownloadCheck) {
    import('./libraries/webpage-download')
      .then(({ default: webpageDownload }) => {
        webpageDownload()
      })
      .catch((error) => {
        console.error("Error loading 'Webpage Download' module:", error)
      })
  }

  const anchorContentCheck = document.querySelector('.c-anchored-content')

  if (anchorContentCheck) {
    import('./partials/anchor-content')
      .then(({ default: anchorContent }) => {
        anchorContent()
      })
      .catch((error) => {
        console.error("Error loading 'Anchor Content' module:", error)
      })
  }

  // Track Progress
  const progressTrackerCheck = document.querySelector('js-track-progress')

  if (progressTrackerCheck) {
    import('./partials/progress-tracker')
      .then(({ default: progressTracker }) => {
        progressTracker()
      })
      .catch((error) => {
        console.error("Error loading 'Progress Tracker' module:", error)
      })
  }

  // Accordion
  const accordionCheck = document.querySelector(
    '.js-slider, .js-accordion__header',
  )

  if (accordionCheck) {
    import('./partials/accordion')
      .then(({ default: accordions }) => {
        accordions()
      })
      .catch((error) => {
        console.error("Error loading 'Accordion' module:", error)
      })
  }

  // Contribution Modal
  const contributorBtnCheck = document.querySelector(
    'button.js-open-contributors, aside.contributors-modal',
  )

  if (contributorBtnCheck) {
    import('./partials/contributors-modal')
      .then(({ default: contributionModal }) => {
        contributionModal()
      })
      .catch((error) => {
        console.error("Error loading 'Contribution Modal' module:", error)
      })
  }

  // Notice
  const noticeCheck = document.getElementById('js-alert')

  if (noticeCheck) {
    import('./partials/alerts')
      .then(({ default: alerts }) => {
        alerts()
      })
      .catch((error) => {
        console.error("Error loading 'Alerts' module:", error)
      })
  }

  // Filter (Grid)
  const filtersGridCheck = document.querySelector('.js-filter')

  if (filtersGridCheck) {
    import('./filters/filter-grid')
      .then(({ default: filterGrid }) => {
        filterGrid()
      })
      .catch((error) => {
        console.error("Error loading 'Filter Grid' module:", error)
      })
  }

  // Filter (Slider)
  const filterSliderdCheck = document.querySelector(
    '.js-slider-filter[data-id]',
  )

  if (filterSliderdCheck) {
    import('./filters/filter-slider')
      .then(({ default: filterSlider }) => {
        filterSlider()
      })
      .catch((error) => {
        console.error("Error loading 'Filter Slider' module:", error)
      })
  }

  // Filter (Bar? Not sure what this does @dan)
  const filterBarCheck = document.querySelector('.c-filters__label')

  if (filterBarCheck) {
    import('./filters/filter-bar')
      .then(({ default: filterBar }) => {
        filterBar()
      })
      .catch((error) => {
        console.error("Error loading 'Filter Bar' module:", error)
      })
  }

  // Filter (Select Input)
  const filterSelectCheck = document.querySelector('.custom-select select')

  if (filterSelectCheck) {
    import('./filters/filter-select')
      .then(({ default: filterSelect }) => {
        filterSelect()
      })
      .catch((error) => {
        console.error("Error loading 'Filter Select' module:", error)
      })
  }

  // Filter (Text Input)
  const filterTextCheck = document.querySelector('.use-ajax')

  if (filterTextCheck) {
    import('./filters/filter-text')
      .then(({ default: filterText }) => {
        filterText()
      })
      .catch((error) => {
        console.error("Error loading 'Filter Text' module:", error)
      })
  }

  // Slider
  const sliderCheck = document.querySelector('.js-slider')

  if (sliderCheck) {
    import('./libraries/slick.min.js')
      .then((module) => {
        $('.js-slider').slick({
          infinite: false,
          dots: false,
          centerMode: false,
          centerPadding: '0px',
          slidesToShow: 4,
          rows: 0,
          speed: 250,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        })
      })
      .catch((error) => {
        console.error("Error loading 'Slick Library' module:", error)
      })
  }

  if (!('backgroundBlendMode' in document.body.style)) {
    var body = document.getElementsByTagName('body')[0]
    body.className = body.className + ' no-background-blend-mode'
  }

  $('body').removeClass('preload')
})

function pushTermToDataLayer() {
  dataLayer.push({
    event: 'search',
    searchTerm: $('.ais-SearchBox-input').val(),
  })
}
